// src/redux/slices/kycSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ApiEncryptDecrypt from "../../Utils/Encryption";
import axiosInstance from "../../Utils/axiosInstance";
const Key = import.meta.env.VITE_Encryption_Decryption_Key;
export const fetchKycDetails = createAsyncThunk(
  "kyc/fetchKycDetails",
  async (_, { rejectWithValue }) => {
    try {
      const getLoggedInUser = sessionStorage.getItem("loggedInUser");
      if (!getLoggedInUser) return rejectWithValue("User not logged in");
      const res = await axiosInstance.post("/Profile/GetKYCDetails", "");

      const obj = JSON.parse(decryptedRes);
      // console.log(res)
      if (obj.Status === 3) {
        return rejectWithValue("Session expired");
      }

      return obj.data;
    } catch (error) {
      return rejectWithValue(error?.message || "Error fetching KYC details");
    }
  }
);

const kycSlice = createSlice({
  name: "kyc",
  initialState: {
    kycDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearKyc: (state) => {
      state.kycDetails = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchKycDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchKycDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.kycDetails = action.payload;
      })
      .addCase(fetchKycDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearKyc } = kycSlice.actions;
export default kycSlice.reducer;
